module.exports = __webpack_public_path__ + "img/evse_item-v2_38x38.8565ddd0.svg";